import { createApiCall2, MethodType, URI } from "../Api";
import { ResetPasswordData } from "models/resetPassword";

export const fetchResetPassword = (payload: ResetPasswordData) => {
  return createApiCall2(MethodType.POST, URI.AUTH.RESETPASSWORD, payload);
};
